import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "admin-page-wr" }
const _hoisted_2 = {
  key: 0,
  class: "dashboard-header"
}
const _hoisted_3 = { class: "subtitle-main" }
const _hoisted_4 = {
  key: 1,
  class: "filters"
}
const _hoisted_5 = { class: "table-wrapper" }
const _hoisted_6 = { class: "table-default" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "bold" }
const _hoisted_9 = { class: "actions" }
const _hoisted_10 = { class: "actions-wr" }
const _hoisted_11 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$props.isConciergeView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "title-main" }, "Stages", -1)),
          _createElementVNode("h3", _hoisted_3, _toDisplayString(`${$setup.stages.length} stage${$setup.stages.length > 1 ? "s" : ""}`), 1)
        ]))
      : _createCommentVNode("", true),
    (!$props.isConciergeView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode($setup["InputSearch"], {
            modelValue: $setup.searchQuery,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchQuery) = $event)),
            placeholder: "Search",
            theme: "filter"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", { class: "buttons" }, [
            _createElementVNode("button", {
              class: "button default primary add-btn-primary",
              onClick: $setup.toCreateStage
            }, "Add Stage")
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", _hoisted_6, [
        _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, "Name"),
            _createElementVNode("th", null, "Status"),
            _createElementVNode("th", null, "Action")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stages, (stage) => {
            return (_openBlock(), _createElementBlock("tr", {
              onClick: ($event: any) => ($setup.toStage(stage._id))
            }, [
              _createElementVNode("td", _hoisted_8, "Stage " + _toDisplayString(stage.title), 1),
              _createElementVNode("td", null, [
                _createElementVNode("div", {
                  class: _normalizeClass(["badge", $setup.getStageStatusClass(stage.status)])
                }, _toDisplayString(stage.status), 3)
              ]),
              _createElementVNode("td", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_router_link, {
                    class: "icon edit",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                    to: { name: 'AdminStageUpdate', params: { userId: $setup.userId, estateId: $setup.estateId, stageId: stage._id } }
                  }, null, 8, ["to"]),
                  _createElementVNode("button", {
                    class: "icon trash",
                    onClick: _withModifiers(($event: any) => ($setup.setItemForDelete(stage)), ["stop"])
                  }, null, 8, _hoisted_11)
                ])
              ])
            ], 8, _hoisted_7))
          }), 256))
        ])
      ])
    ]),
    _createVNode($setup["ConfirmDeleteModal"], {
      isOpen: $setup.showConfirmDeleteModal,
      deleteItem: $setup.itemForDelete.title,
      onClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.showConfirmDeleteModal = false)),
      onConfirm: _cache[3] || (_cache[3] = ($event: any) => ($setup.deleteStage($setup.itemForDelete.id)))
    }, null, 8, ["isOpen", "deleteItem"])
  ]))
}